module.exports = __webpack_public_path__ + "static/img/bg_home_purchase.dba110b2.png";